import { lazy } from "react";
import { v4 } from "uuid";

export const SelectFilterOptions = [
  {
    id: v4(),
    value: "pending",
    name: "معلق",
  },
  {
    id: v4(),
    value: "accepted",
    name: "مقبول",
  },
  {
    id: v4(),
    value: "rejected",
    name: "مرفوض",
  },
  {
    id: v4(),
    value: "",
    name: "جميع الطلبات",
  },
];

export const topBlocksData = [
  {
    id: "2",
    icon: require("../src/assets/svgs/ticketsIcon.svg").default,
    title: "المديرين",
    subtitle: "عرض المديرين",
    url: "admins",
  },
  {
    id: "3",
    icon: require("../src/assets/svgs/tasksIcon.svg").default,
    title: "الطلبات",
    subtitle: "عرض الطلبات",
    url: "orders",
  },
  {
    id: "4",
    icon: require("../src/assets/svgs/employeeIcon.svg").default,
    title: "السائقين",
    subtitle: "عرض السائقين",
    url: "drivers",
  },
  {
    id: "5",
    icon: require("../src/assets/svgs/customerIcon.svg").default,
    title: "المشتركين",
    subtitle: "عرض المشتركين",
    url: "subscribers",
  },
  {
    id: "6",
    icon: require("../src/assets/svgs/paymentIcon.svg").default,
    title: "البنوك",
    subtitle: "عرض البنوك",
    url: "banks",
  },
  {
    id: "1",
    icon: require("../src/assets/svgs/projectsIcon.svg").default,
    title: "الصلاحيات",
    subtitle: "عرض الصلاحيات",
    url: "roles",
  },
];

export const activeCustomersData = [
  {
    id: "1",
    url: require("../src/assets/images/customer.png").default,
    name: "محمد إبرهيم",
    subtitle: "Spent this month",
  },
  {
    id: "2",
    url: require("../src/assets/images/customer.png").default,
    name: "محمد إبرهيم",
    subtitle: "Spent this month",
  },
];

export const activeUsersData = [
  {
    id: "1",
    url: require("../src/assets/images/emp1.png").default,
    name: "سهام سامي",
    job: "Back End developer",
  },
  {
    id: "2",
    url: require("../src/assets/images/emp2.png").default,
    name: "محمد إبرهيم",
    job: "ui/ux designer",
  },
  {
    id: "3",
    url: require("../src/assets/images/emp3.png").default,
    name: "عمار ياسر",
    job: "front end developer",
  },
];

export const reportBlocksData = [
  {
    id: "1",
    title: "طلب توصيل",
    dateRange: "31/01/2020 – 06/02/2021",
    name: "طلب توصيل منتجات الي العميل ",
    body: "مجموعه منتجات مختاره للتوصيل الي المكان المحدد في الوقت المختار",
    lang: "توصيل سريع",
    cost: "2000 ريال",
    className: "card-green-bg",
  },
  {
    id: "2",
    title: "طلب توصيل",
    dateRange: "31/01/2020 – 06/02/2021",
    name: "طلب توصيل منتجات الي العميل ",
    body: "مجموعه منتجات مختاره للتوصيل الي المكان المحدد في الوقت المختار",
    lang: "توصيل سريع",
    cost: "2000 ريال",
    className: "card-red-bg",
  },
  {
    id: "3",
    title: "طلب توصيل",
    dateRange: "31/01/2020 – 06/02/2021",
    name: "طلب توصيل منتجات الي العميل ",
    body: "مجموعه منتجات مختاره للتوصيل الي المكان المحدد في الوقت المختار",
    lang: "توصيل سريع",
    cost: "2000 ريال",
    className: "card-blue-bg",
  },
  {
    id: "4",
    title: "طلب توصيل",
    dateRange: "31/01/2020 – 06/02/2021",
    name: "طلب توصيل منتجات الي العميل ",
    body: "مجموعه منتجات مختاره للتوصيل الي المكان المحدد في الوقت المختار",
    lang: "توصيل سريع",
    cost: "2000 ريال",
    className: "card-green-bg",
  },
];

export const projectsTableHead = [
  {
    name: "الأسم ",
  },
  {
    name: " الموقع",
  },
  {
    name: "نوع السائق",
  },
];
export const projectsTableHeadForReports = [
  {
    driver: " السائق",
  },
  {
    status: " الحاله",
  },
  {
    date: " التاريخ",
  },
];

export const projectsTableData = [
  {
    id: "1",
    name: "هاف ميل المحدودة (Halfmilelimited) 123",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "2",
    name: "هاف ميل المحدودة (Halfmilelimited)",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "3",
    name: "هاف ميل المحدودة (Halfmilelimited)",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "red",
  },
  {
    id: "4",
    name: "هاف ميل المحدودة (Halfmilelimited)",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "red",
  },
  {
    id: "5",
    name: "هاف ميل المحدودة (Halfmilelimited)",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "red",
  },
  {
    id: "6",
    name: "هاف ميل المحدودة (Halfmilelimited)",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "7",
    name: "هاف ميل المحدودة (Halfmilelimited)",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "blue",
  },
  {
    id: "8",
    name: "هاف ميل المحدودة (Halfmilelimited)",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "blue",
  },
  {
    id: "9",
    name: "هاف ميل المحدودة (Halfmilelimited)",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "10",
    name: "هاف ميل المحدودة (Halfmilelimited)",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "11",
    name: "هاف ميل المحدودة (Halfmilelimited)",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "red",
  },
  {
    id: "12",
    name: "هاف ميل المحدودة (Halfmilelimited)",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "13",
    name: "هاف ميل المحدودة (Halfmilelimited)",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "blue",
  },
  {
    id: "14",
    name: "هاف ميل المحدودة (Halfmilelimited)",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "blue",
  },
  {
    id: "15",
    name: "هاف ميل المحدودة (Halfmilelimited)",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "16",
    name: "هاف ميل المحدودة (Halfmilelimited)",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "17",
    name: "هاف ميل المحدودة (Halfmilelimited)",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "18",
    name: "هاف ميل المحدودة (Halfmilelimited)",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "19",
    name: "هاف ميل المحدودة (Halfmilelimited)",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "20",
    name: "هاف ميل المحدودة (Halfmilelimited)",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "21",
    name: "هاف ميل المحدودة (Halfmilelimited)",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "22",
    name: "هاف ميل المحدودة (Halfmilelimited)",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "23",
    name: "هاف ميل المحدودة (Halfmilelimited)",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "24",
    name: "هاف ميل المحدودة (Halfmilelimited)",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "25",
    name: "هاف ميل المحدودة (Halfmilelimited)",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "26",
    name: "هاف ميل المحدودة (Halfmilelimited)",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "27",
    name: "هاف ميل المحدودة (Halfmilelimited)",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "28",
    name: "هاف ميل المحدودة (Halfmilelimited)",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "29",
    name: "هاف ميل المحدودة (Halfmilelimited)",
    client: "مروي سعد",
    type: "سائق مميز",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
];

export const paymentCardsData = [
  {
    id: "1",
    url: require("../src/assets/images/banks/1.png").default,
    status: true,
  },
  {
    id: "2",
    url: require("../src/assets/images/banks/2.png").default,
    status: true,
  },
  {
    id: "3",
    url: require("../src/assets/images/banks/3.png").default,
    status: true,
  },
  {
    id: "4",
    url: require("../src/assets/images/banks/4.png").default,
  },
  {
    id: "5",
    url: require("../src/assets/images/banks/5.png").default,
  },
  {
    id: "6",
    url: require("../src/assets/images/banks/6.png").default,
    status: true,
  },
];

export const ticketsTableData = [
  {
    id: "1",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "2",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "3",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "red",
  },
  {
    id: "4",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "red",
  },
  {
    id: "5",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "red",
  },
  {
    id: "6",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "7",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "blue",
  },
  {
    id: "8",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "blue",
  },
  {
    id: "9",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "10",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "11",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "red",
  },
  {
    id: "12",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "13",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "blue",
  },
  {
    id: "14",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "blue",
  },
  {
    id: "15",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "16",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "17",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "18",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "19",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "20",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
];

export const tasksTableData = [
  {
    id: "1",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "2",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "3",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "red",
  },
  {
    id: "4",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "red",
  },
  {
    id: "5",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "red",
  },
  {
    id: "6",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "7",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "blue",
  },
  {
    id: "8",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "blue",
  },
  {
    id: "9",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "10",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "11",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "red",
  },
  {
    id: "12",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "13",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "blue",
  },
  {
    id: "14",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "blue",
  },
  {
    id: "15",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "16",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "17",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "18",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "19",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
  {
    id: "20",
    name: "#12542154",
    client: "مروي سعد",
    type: "متجر إلكتروني",
    showButtons: true,
    showStatus: true,
    className: "green",
  },
];

export const reportsItemsData = [
  {
    id: "1",
    path: require("../src/assets/svgs/customerIcon.svg").default,
    title: "تقارير العملاء",
    subtitle: "Spent this month",
    className: "itemTheme1",
    url: "customers-reports",
    xxl: "4",
    sm: "6",
    xs: "12",
  },
  {
    id: "2",
    path: require("../src/assets/svgs/employeeIcon.svg").default,
    title: "تقارير الموظفون",
    subtitle: "Spent this month",
    className: "itemTheme2",
    url: "customers-reports",
    xxl: "4",
    sm: "6",
    xs: "12",
  },
  {
    id: "3",
    path: require("../src/assets/svgs/paymentIcon.svg").default,
    title: "تقارير المالية",
    subtitle: "Spent this month",
    className: "itemTheme3",
    url: "customers-reports",
    xxl: "4",
    sm: "6",
    xs: "12",
  },
  {
    id: "4",
    path: require("../src/assets/svgs/projectsIcon.svg").default,
    title: "تقارير المشاريع",
    subtitle: "Spent this month",
    className: "itemTheme4",
    url: "customers-reports",
    xxl: "4",
    sm: "6",
    xs: "12",
  },
  {
    id: "5",
    path: require("../src/assets/svgs/ticketsIcon.svg").default,
    title: "تقارير التذاكر",
    subtitle: "Spent this month",
    className: "itemTheme5",
    url: "customers-reports",
    xxl: "4",
    sm: "6",
    xs: "12",
  },
  {
    id: "6",
    path: require("../src/assets/svgs/tasksIcon.svg").default,
    title: "تقارير المهام",
    subtitle: "Spent this month",
    className: "itemTheme6",
    url: "customers-reports",
    xxl: "4",
    sm: "6",
    xs: "12",
  },
];

export const customersReportsData = [
  {
    id: "1",
    path: require("../src/assets/images/pieChart.png").default,
    title: "تقرير العملاء خلال اليوم",
    subtitle: "Spent this month",
    url: "customers-reports",
  },
  {
    id: "2",
    path: require("../src/assets/images/pieChart.png").default,
    title: "تقرير عدد مدخلات المبيعات",
    subtitle: "Spent this month",
    url: "customers-reports",
  },
  {
    id: "3",
    path: require("../src/assets/images/pieChart.png").default,
    title: "تقرير عملاء التسويق",
    subtitle: "Spent this month",
    url: "customers-reports",
  },
  {
    id: "4",
    path: require("../src/assets/images/pieChart.png").default,
    title: "تقرير عملاء التسويق",
    subtitle: "Spent this month",
    url: "customers-reports",
  },
  {
    id: "5",
    path: require("../src/assets/images/pieChart.png").default,
    title: "تقرير العملاء خلال اليوم",
    subtitle: "Spent this month",
    url: "customers-reports",
  },
];

export const employeeListData = [
  {
    id: "1",
    path: require("../src/assets/images/user.gif").default,
    title: "Mohamed ibrahim",
    subtitle: "Creating UI and Research",
    url: "",
    login: "09:00 AM",
    logout: "05:00 PM",
  },
  {
    id: "2",
    path: require("../src/assets/images/user.gif").default,
    title: "Mohamed ibrahim",
    subtitle: "Creating UI and Research",
    url: "",
    login: "09:00 AM",
    logout: "05:00 PM",
  },
  {
    id: "3",
    path: require("../src/assets/images/user.gif").default,
    title: "Mohamed ibrahim",
    subtitle: "Creating UI and Research",
    url: "",
    login: "09:00 AM",
    logout: "05:00 PM",
  },
  {
    id: "4",
    path: require("../src/assets/images/user.gif").default,
    title: "Mohamed ibrahim",
    subtitle: "Creating UI and Research",
    url: "",
    login: "09:00 AM",
    logout: "05:00 PM",
  },
  {
    id: "5",
    path: require("../src/assets/images/user.gif").default,
    title: "Mohamed ibrahim",
    subtitle: "Creating UI and Research",
    url: "",
    login: "09:00 AM",
    logout: "05:00 PM",
  },
];

export const CustomersListData = [
  {
    id: "1",
    path: require("../src/assets/images/user.png").default,
    title: "Mohamed ibrahim",
    subtitle: "ecommerce website",
    type: "ecommerce",
    status: "active",
  },
  {
    id: "2",
    path: require("../src/assets/images/user.png").default,
    title: "Mohamed ibrahim",
    subtitle: "ecommerce website",
    type: "ecommerce",
    status: "away",
  },
  {
    id: "3",
    path: require("../src/assets/images/user.png").default,
    title: "Mohamed ibrahim",
    subtitle: "ecommerce website",
    type: "ecommerce",
    status: "away",
  },
  {
    id: "4",
    path: require("../src/assets/images/user.png").default,
    title: "Mohamed ibrahim",
    subtitle: "ecommerce website",
    type: "ecommerce",
    status: "active",
  },
  {
    id: "5",
    path: require("../src/assets/images/user.png").default,
    title: "Mohamed ibrahim",
    subtitle: "ecommerce website",
    type: "ecommerce",
    status: false,
  },
];

export const permissionsItemsData = [
  {
    id: "1",
    path: require("../src/assets/svgs/groupIcon.svg").default,
    title: "انشاء مجموعه جديدة",
    subtitle: "Spent this month",
    className: "itemTheme7",
    url: "customers-reports",
    xxl: "7",
    lg: "10",
    md: "12",
  },
  {
    id: "2",
    path: require("../src/assets/svgs/customerIcon.svg").default,
    title: "مجموعات المستخدمين",
    subtitle: "Spent this month",
    className: "itemTheme8",
    url: "customers-reports",
    xxl: "7",
    lg: "10",
    md: "12",
  },
];

export const permissionsItemsBigData = [
  {
    id: "1",
    path: require("../src/assets/svgs/groupIcon.svg").default,
    title: "صلاحيات الموظفين",
    subtitle: "Spent this month",
    className: "bigCard itemGray",
    url: "customers-reports",
    xxl: "7",
    lg: "10",
    md: "12",
  },
  {
    id: "2",
    path: require("../src/assets/svgs/customerIcon.svg").default,
    title: "صلاحيات العملاء",
    subtitle: "Spent this month",
    className: "bigCard itemGray",
    url: "customers-reports",
    xxl: "7",
    lg: "10",
    md: "12",
  },
];

export const sidebarData = [
  {
    id: v4(),
    to: "/",
    text: "home",
    svg: (
      <svg
        width="20"
        height="19"
        viewBox="0 0 20 19"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 18.9103H2C0.89543 18.9103 0 17.9957 0 16.8675V2.56837C0 1.4402 0.89543 0.525635 2 0.525635H18C19.1046 0.525635 20 1.4402 20 2.56837V16.8675C20 17.9957 19.1046 18.9103 18 18.9103ZM2 4.6111V16.8675H18V4.6111H2ZM16 14.8248H10V12.782H16V14.8248ZM5.414 14.8248L4 13.3806L6.293 11.0396L4 8.69658L5.414 7.25236L9.12 11.0386L5.415 14.8248H5.414Z"
          fill="#A3AED0"
        />
      </svg>
    ),
  },
  {
    id: v4(),
    to: "/drivers?page=1",
    text: "drivers",
    permission: "drivers-index",

    svg: (
      <svg
        width="19"
        height="24"
        viewBox="0 0 19 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.5498 13.8423H10.1783V15.4708H8.5498V13.8423Z"
          fill="#A3AED0"
        />
        <path
          d="M10.9925 13.8421V15.8777C10.9925 15.9857 10.9496 16.0893 10.8733 16.1656C10.7969 16.2419 10.6933 16.2848 10.5854 16.2848H8.14262C7.9178 16.2848 7.7355 16.1025 7.7355 15.8777V13.8421H4.88563V21.5774H13.8424V13.8421H10.9925ZM4.4785 22.3917C4.25368 22.3917 4.07138 22.2094 4.07138 21.9846V19.5947C3.72205 19.685 3.41253 19.8886 3.19152 20.1738C2.97033 20.4589 2.8502 20.8095 2.85001 21.1703V23.6131H6.10701C6.46779 23.6129 6.81839 23.4927 7.10356 23.2716C7.38873 23.0505 7.59229 22.741 7.6826 22.3917L4.4785 22.3917ZM18.6097 20.8039L16.3747 13.8423C16.1151 13.0172 15.5995 12.2962 14.9027 11.7836C14.2058 11.2712 13.3638 10.9941 12.4988 10.9924H11.3589C11.3512 11.0295 11.3418 11.0662 11.3303 11.1024C11.1766 11.6862 10.7716 12.1715 10.2247 12.4274C9.67801 12.6833 9.04587 12.6833 8.49897 12.4274C7.95226 12.1715 7.54733 11.6862 7.39336 11.1024L7.36901 10.9924H6.22906C5.36409 10.9941 4.52202 11.2712 3.82521 11.7836C3.12835 12.2962 2.61272 13.0172 2.35319 13.8423L0.118189 20.8039C0.0382153 21.054 -0.00158486 21.315 4.82893e-05 21.5774C-0.00322322 22.157 0.199795 22.719 0.572581 23.1627C0.945535 23.6065 1.46407 23.9033 2.03567 23.9998V21.1703C2.03622 20.5935 2.24105 20.0354 2.61346 19.5951C2.98605 19.1547 3.50258 18.8605 4.07129 18.7643V13.4349C4.07129 13.2101 4.25359 13.0278 4.47842 13.0278H14.2494C14.3574 13.0278 14.461 13.0707 14.5373 13.1471C14.6136 13.2234 14.6565 13.327 14.6565 13.4349V18.7643C15.2252 18.8605 15.7418 19.1547 16.1144 19.5951C16.4868 20.0355 16.6916 20.5935 16.6922 21.1703V23.9795C17.1903 23.8942 17.6496 23.6567 18.0071 23.2996C18.327 22.9789 18.5524 22.5765 18.6587 22.1363C18.7649 21.6961 18.748 21.2352 18.6097 20.8039H18.6097ZM14.6566 19.5825V21.9846C14.6566 22.0925 14.6137 22.1961 14.5373 22.2725C14.461 22.3488 14.3574 22.3917 14.2494 22.3917H11.0454C11.1357 22.741 11.3392 23.0505 11.6244 23.2715C11.9096 23.4927 12.2602 23.6129 12.6209 23.6131H15.8779V21.1703C15.8778 20.8095 15.7576 20.4589 15.5364 20.1738C15.3154 19.8886 15.0059 19.685 14.6566 19.5947L14.6566 19.5825ZM13.8423 13.8418H10.9924V15.8775C10.9924 15.9854 10.9496 16.089 10.8732 16.1654C10.7969 16.2417 10.6933 16.2846 10.5853 16.2846H8.14258C7.91775 16.2846 7.73545 16.1023 7.73545 15.8775V13.8418H4.88558V21.5772H13.8423V13.8418ZM4.47846 22.3915C4.25363 22.3915 4.07133 22.2092 4.07133 21.9843V19.5945C3.722 19.6848 3.41249 19.8884 3.19148 20.1735C2.97029 20.4587 2.85015 20.8093 2.84997 21.1701V23.6128H6.10696C6.46774 23.6126 6.81834 23.4925 7.10351 23.2713C7.38868 23.0503 7.59225 22.7408 7.68256 22.3915L4.47846 22.3915ZM10.9924 13.8418V15.8775C10.9924 15.9854 10.9496 16.089 10.8732 16.1654C10.7969 16.2417 10.6933 16.2846 10.5853 16.2846H8.14258C7.91775 16.2846 7.73545 16.1023 7.73545 15.8775V13.8418H4.88558V21.5772H13.8423V13.8418H10.9924Z"
          fill="#A3AED0"
        />
        <path
          d="M10.5855 10.4141V10.5851C10.5868 10.6883 10.5731 10.7912 10.5448 10.8904C10.4539 11.2427 10.2109 11.536 9.88176 11.6909C9.55261 11.8455 9.17164 11.8455 8.8425 11.6909C8.51335 11.536 8.27015 11.2427 8.17947 10.8904C8.15311 10.7908 8.14094 10.6881 8.14276 10.5851V10.4141C8.31505 10.465 8.49045 10.5044 8.66802 10.5322H8.83504H8.83486C8.90811 10.5362 8.98153 10.5362 9.05478 10.5322H9.36412H9.67346C9.74671 10.5362 9.82014 10.5362 9.89339 10.5322H10.0604H10.0602C10.2378 10.5044 10.4132 10.465 10.5855 10.4141H10.5855Z"
          fill="#A3AED0"
        />
        <path
          d="M8.14258 10.4141C8.31488 10.465 8.49027 10.5044 8.66784 10.5322C8.49045 10.5033 8.31506 10.4639 8.14258 10.4141ZM10.0601 10.5322C10.2376 10.5044 10.413 10.465 10.5853 10.4141C10.4128 10.4639 10.2375 10.5033 10.0601 10.5322Z"
          fill="#A3AED0"
        />
        <path
          d="M13.0284 5.37389V6.10672C13.0283 7.20902 12.5317 8.25266 11.6766 8.94821C10.8214 9.64396 9.69853 9.91768 8.6193 9.69341C8.37121 9.64271 8.12968 9.56492 7.89867 9.4615C7.24583 9.17651 6.69018 8.70741 6.29962 8.11161C5.90922 7.51581 5.70094 6.819 5.7002 6.1067V5.36987L5.82233 5.43494L5.99736 5.51636C6.09096 5.55308 6.18874 5.58561 6.28634 5.61415L6.44101 5.65086C6.52244 5.65086 6.59987 5.6794 6.68129 5.68757V5.68739C6.76108 5.69557 6.84141 5.69975 6.92157 5.69957H11.8071C11.887 5.70375 11.9672 5.70375 12.0473 5.69957H12.1938C12.2489 5.69303 12.3034 5.68212 12.3567 5.66704C12.4105 5.65722 12.4636 5.64359 12.5155 5.62632C12.593 5.60342 12.6691 5.57616 12.7434 5.5449C12.842 5.49401 12.9372 5.43676 13.0284 5.37387V5.37389Z"
          fill="#A3AED0"
        />
        <path
          d="M13.411 2.8499H5.31738C5.41008 2.13178 5.73796 1.46475 6.24977 0.952793C6.85771 0.339547 7.68652 -0.00360073 8.55004 2.84975e-05H10.1785C10.9721 -0.000153243 11.7383 0.289194 12.3336 0.813905C12.9288 1.33861 13.3119 2.06254 13.4112 2.8499H13.411Z"
          fill="#A3AED0"
        />
        <path
          d="M13.3824 3.66406C13.3288 3.8718 13.2347 4.06682 13.1056 4.23804C13.0625 4.29874 13.0149 4.35581 12.9631 4.40907C12.6563 4.7155 12.2403 4.88692 11.8068 4.88543H6.9213C6.56052 4.88525 6.20992 4.76511 5.92475 4.54392C5.63958 4.32291 5.43601 4.0134 5.3457 3.66406H13.3824Z"
          fill="#A3AED0"
        />
        <path
          d="M14.6561 4.88564V5.29277C14.6563 5.5454 14.5779 5.79202 14.4322 5.99832C14.2864 6.20461 14.0801 6.36074 13.8418 6.44489V6.10702V4.60065C13.9867 4.38855 14.0941 4.153 14.1593 3.90454C14.4712 4.13428 14.6555 4.49834 14.6561 4.88564H14.6561Z"
          fill="#A3AED0"
        />
        <path
          d="M4.88556 6.44465C4.64728 6.3605 4.441 6.20437 4.29521 5.99808C4.14944 5.79179 4.07111 5.54515 4.07129 5.29252V4.8854C4.07183 4.49808 4.25613 4.13405 4.56803 3.9043C4.63328 4.15275 4.74069 4.38829 4.88555 4.60041V6.10677V6.44465H4.88556Z"
          fill="#A3AED0"
        />
      </svg>
    ),
    children: [
      {
        id: v4(),
        to: "/drivers/underreview",
        text: "السائقين تحت المراجعه",
      },
      {
        id: v4(),
        to: "/drivers/adddriver",
        text: "اضافه سائق",
      },
    ],
  },
  {
    id: v4(),
    to: "/transactionrequests",
    text: "transfer-requests",
    permission: "driverTransactionRequests-index",
    svg: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 21H4C2.89543 21 2 20.1046 2 19V5C2 3.89543 2.89543 3 4 3H20C21.1046 3 22 3.89543 22 5V19C22 20.1046 21.1046 21 20 21ZM4 7V19H20V7H4ZM18 17H12V15H18V17ZM7.414 17L6 15.586L8.293 13.294L6 11L7.414 9.586L11.12 13.293L7.415 17H7.414Z"
          fill="#A3AED0"
        />
      </svg>
    ),
  },
  {
    id: v4(),
    to: "/admins",
    text: "admins",
    permission: "admins-index",

    svg: (
      <svg
        width="24"
        height="26"
        viewBox="0 0 24 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 23.41L9 20.3459H5C3.89543 20.3459 3 19.4313 3 18.3032V5.0254C3 3.89723 3.89543 2.98267 5 2.98267H19C20.1046 2.98267 21 3.89723 21 5.0254V18.3032C21 19.4313 20.1046 20.3459 19 20.3459H15L12 23.41ZM5 5.0254V18.3032H10L12 20.3459L14 18.3032H19V5.0254H5ZM16 16.2461H8V15.8519C8.11835 13.7122 9.90424 12.0706 12 12.175C14.0958 12.0706 15.8816 13.7122 16 15.8519V16.2451V16.2461ZM12 11.1536C11.4641 11.1726 10.9445 10.9635 10.5653 10.5762C10.1861 10.189 9.98138 9.65825 10 9.11087C9.98168 8.56358 10.1865 8.03306 10.5656 7.64584C10.9447 7.25862 11.4642 7.04942 12 7.06814C12.5358 7.04942 13.0553 7.25862 13.4344 7.64584C13.8135 8.03306 14.0183 8.56358 14 9.11087C14.0186 9.65825 13.8139 10.189 13.4347 10.5762C13.0555 10.9635 12.5359 11.1726 12 11.1536Z"
          fill="#A3AED0"
        />
      </svg>
    ),
    children: [
      {
        id: v4(),
        to: "/admins/addadmin",
        text: "اضافه مدير",
      },
    ],
  },

  {
    id: v4(),
    to: "/orders",
    text: "orders",
    permission: "orders-index",

    svg: (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 21.8088L3 14.6592L4.62 13.3723L11.99 19.2248L19.37 13.3621L21 14.6592L12 21.8088ZM12 17.4476L4.63 11.5951L3 10.298L12 3.14844L21 10.298L19.36 11.5951L12 17.4476Z"
          fill="#A3AED0"
        />
      </svg>
    ),
    children: [],
  },

  {
    id: v4(),
    to: "/subscribers",
    text: "subscribers",
    // permission: "subscribers-index",

    svg: (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 21.9322H5C3.89543 21.9322 3 21.0177 3 19.8895V5.59034C3 4.46217 3.89543 3.54761 5 3.54761H19C20.1046 3.54761 21 4.46217 21 5.59034V19.8895C21 21.0177 20.1046 21.9322 19 21.9322ZM5 5.59034V19.8895H19V5.59034H5ZM17 17.8468H15V10.6972H17V17.8468ZM13 17.8468H11V7.63308H13V17.8468ZM9 17.8468H7V12.7399H9V17.8468Z"
          fill="#A3AED0"
        />
      </svg>
    ),
    children: [],
  },

  {
    id: v4(),
    to: "/settings",
    text: "settings",
    permission: "settings-index",
    svg: (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 21.9322H5C3.89543 21.9322 3 21.0177 3 19.8895V5.59034C3 4.46217 3.89543 3.54761 5 3.54761H19C20.1046 3.54761 21 4.46217 21 5.59034V19.8895C21 21.0177 20.1046 21.9322 19 21.9322ZM5 5.59034V19.8895H19V5.59034H5ZM17 17.8468H15V10.6972H17V17.8468ZM13 17.8468H11V7.63308H13V17.8468ZM9 17.8468H7V12.7399H9V17.8468Z"
          fill="#A3AED0"
        />
      </svg>
    ),
    children: [
      {
        id: v4(),
        to: "/settings/main",
        text: " الاعدادات العامه ",
      },
      {
        id: v4(),
        to: "/settings/social",
        text: "اعدادات السوشيال ميديا ",
      },
      {
        id: v4(),
        to: "/settings/roles",
        text: "الصلاحيات",
      },
      {
        id: v4(),
        to: "/settings/banks",
        text: "البنوك ",
      },
      {
        id: v4(),
        to: "/settings/contacts",
        text: "بيانات التواصل ",
      },
    ],
  },
];

// fututre refacrot i could assign a function to the start of the path

// to append the ./views or should i use absoulute modules
export const appRoutes = [
  {
    id: v4(),
    path: "/",
    pathToElement: "views/dashboard",
    Element: lazy(() => import("views/dashboard")),
    perrmission: "index",
  },
  // {
  //   id: v4(),
  //   path: "/dashboard",
  //   pathToElement: "views/dashboard",
  // },
  // {
  //   id: v4(),
  //   path: "/drivers",
  //   pathToElement: "./views/drivers/Index",
  // },
  // {
  //   id: v4(),
  //   path: "/drivers/adddriver",
  //   pathToElement: "./views/drivers/AddDriver",
  // },
  // {
  //   id: v4(),
  //   path: "/drivers/:id",
  //   pathToElement: "./views/drivers/editDriver",
  // },
  // {
  //   id: v4(),
  //   path: "/admins",
  //   pathToElement: "./views/admins/addadmin",
  // },

  // {
  //   id: v4(),
  //   path: "/admins/addadmin",
  //   pathToElement: "./views/admins/addAdmin",
  // },
  // {
  //   id: v4(),
  //   path: "/admins/:id",
  //   pathToElement: "./views/admins/editAdmin",
  // },
];

export const adminTypes = [
  {
    id: v4(),
    type: "admin",
  },
  {
    id: v4(),
    type: "driver",
  },
];
export const paymentTypes = [
  {
    id: v4(),
    type: "debit",
    placeholder: "مدين",
  },
  {
    id: v4(),
    type: "credit",
    placeholder: "دائن",
  },
];

export const orderStatus = [
  {
    id: v4(),
    type: "manual",
    placeholder: "نظام",
  },
  {
    id: v4(),
    type: "transfer",
    placeholder: "تحويل بنكي",
  },
];

export const operationTypes = [
  {
    id: v4(),
    type: "manual",
    placeholder: "نظام",
  },
  {
    id: v4(),
    type: "transfer",
    placeholder: "تحويل بنكي",
  },
];

export const driverStatus = [
  {
    id: v4(),
    placeholder: "معلق",
    type: "pending",
  },
  {
    id: v4(),
    placeholder: "تحت المراجعه",
    type: "underReview",
  },
  {
    id: v4(),
    placeholder: "خطأ في المراجعه",
    type: "reviewError",
  },
  {
    id: v4(),
    placeholder: "موافق عليه",
    type: "approved",
  },
  {
    id: v4(),
    placeholder: "محظور",
    type: "blocked",
  },
];
export const subscriberStatus = [
  {
    id: v4(),
    placeholder: "معلق",
    type: "pending",
  },
  {
    id: v4(),
    placeholder: "موافق عليه",
    type: "approved",
  },
  {
    id: v4(),
    placeholder: "محظور",
    type: "blocked",
  },
];

export const transactionErrorMessage = "لايوجد حسابات بنكيه لاتمام التحويل";
